import Immutable from 'seamless-immutable';
import { createReducer, onSetValue, onReadValue } from 'redux-recompose';

import { actions } from './actions';

const reducerDescription = {
  [actions.OPEN_MODAL_WITH_DATA]: onReadValue(),
  [actions.CLOSE_MODAL_WITH_DATA]: onReadValue(),
  [actions.OPEN_MODAL]: onSetValue(true),
  [actions.CLOSE_MODAL]: onSetValue(false),
  [actions.CLEAR_MODALS]: () => new Immutable({}),
  [actions.OPEN_PIZZAS_MODAL]: onReadValue()
};

const reducer = createReducer(new Immutable({}), reducerDescription);

export default reducer;
